const componentsCommon=require("cb-components-common").default;
const request=componentsCommon.request;
export function portfolioRisk(params) {
    const _params = params || {};
    return request({
        url: "/ui-api/v1/portfolio-risk",
        method: "post",
        data: _params
    });
}

export function getFundCache(params) {
    const _params = params || {};
    return request({
        url: "/ui-api/v1/fund-cache",
        method: "get",
        params: _params
    });
}

export function getFundRiskLevelParam(params) {
    const _params = params || {};
    return request({
        url: "/ui-api/v1/fund-risk-Level-param",
        method: "get",
        params: _params
    });
}
